import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from 'axios'

const ListSchools = () => {
  const [Schools, setSchools] = useState([])
  const [filterText] = useState("");
  const columns = [
    {
      name: "Name",
      selector: (row) => row.schoolName,
    },
    {
      name: "Operator",
      selector: (row) => row.operatorName,
    },
  ];

  const filteredData = Schools.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );
  useEffect(() => {
    const getSchools = () => {
      var config = {
        method: "Get",
        url: process.env.REACT_APP_API_URL + "Schools/GetSchools/",
        headers: {
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };

      api(config)
        .then(function (response) {
          if (response.data.statusCode === 200) {
            setSchools(response.data.content);
          }
        })
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            window.location = "/Login";
            window.location.reload();
          }
        });
    };
    getSchools();
  }, []);
  return (
    <>
      <div className="container-fluid mt-30">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Schools List</h3>
            <div className="align-self-center">
                <Link to="/Settings/Schools/0" className="btn btn-primary btn-sm cts-btn-primary">Add School</Link>
            </div>
          </div>
          <div className="card-body">
          <DataTable data={filteredData} columns={columns}/>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListSchools;
